<template>
<loader v-bind="{ loading }">

  <div class="columns">
    <div class="column">
      <p>
        First stage scraping
      </p>
    </div>
  </div>

  <columns>
    <column>
      <text-input v-model="filters.search" classes="is-rounded">
        <template #right>
          <div class="buttons has-addons is-rounded">
            <action-button @click="clearFilters" v-if="filters.search.length" class="is-rounded">
              <icon icon="times"/>
            </action-button>
            <action-button @click="runFilters" class="is-rounded">
              <icon icon="search"/>
              <span>Search</span>
            </action-button>
          </div>
        </template>
      </text-input>
    </column>
    <column class="is-narrow is-flex align-end">
      <router-link 
        class="button is-small is-rounded"
        :to="{
          name: 'create-scraper'
        }">
        <icon icon="plus"/>
        <span>Scraper</span>
      </router-link>
    </column>
  </columns>

  <div>
    <div class="table-container">
      <table class="table is-fullwidth is-hoverable">
        <thead>
          <tr>
            <th>Scraper</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="scraper in scrapers.data" :key="scraper.id">
            <td>
              <router-link
                :to="{
                  name: 'edit-scraper',
                  params: {
                    scraper: scraper.id
                  }
                }">{{ scraper.name }}</router-link>
              <p class="has-text-grey">
                {{ scraper.description }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <pager 
        class="mb-1"
        :pageable="scrapers" 
        @nav="goToPage"
        jump-controls
        context="Scraper"/>
    </div>
  </div>
</loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Scrapers',

  data: () => ({
    scrapers: new Paginator,
    loading: true,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadScrapers()
  },

  methods: {
    loadScrapers() {
      getPath({
        path: 'api/super' + this.$route.fullPath
      }, ({data}) => {
        this.scrapers = data
        this.loading = false
      }, error => {})
    },
    runFilters() {
      if(!this.filters.search.length) {
        this.$toast.warning('Please enter a search term.')
        return
      }
      this.$router.push({
        name: 'scrapers',
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'scrapers',
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    },
    secondaryScrapers(attributeTypes) {
      return attributeTypes.reduce((sum, type) => sum + type.secondary_scrapers.length, 0)
    }
  },

  watch: {
    '$route': 'loadScrapers'
  }

}
</script>
